import trialshoppyLogo from "../images/trialshoppy_logo.jpeg";
import nextcallerLogo from "../images/nextcaller_logo.jpeg";
import nitpatnaLogo from "../images/nitp_logo.png";
export const Bio = {
  name: "Madhav Murari",
  roles: [
    "Full Stack Developer",
    "software  Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    " I am a aspiring software developer eager to contribute my enthusiasm and fresh perspective to the world of coding. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Madhav-Murari",
  resume:
    "https://drive.google.com/file/d/1RHR7awn3KJrEz5tamMzyA9p3oQF7smqd/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/madhav-murari-771676220/",
  twitter: "https://twitter.com/MadhavMurari16",
  insta: "https://www.instagram.com/immadhav23?igsh=eTZxeWZzZndyMjR5",
  facebook: "https://www.instagram.com/immadhav23?igsh=eTZxeWZzZndyMjR5",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
   
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Jquery",
        image:
          "https://w7.pngwing.com/pngs/1004/13/png-transparent-jquery-hd-logo.png",
      },
      {
        name: "Ejs",
        image:
          "https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_ejs_icon_130626.png",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
   
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg",

      },
      {
        name: "Redis",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original-wordmark.svg",
      },
      {
        name: "Flask",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original-wordmark.svg",
      }
    ],
  },
  {
    title: "Programming Skills",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "c++",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "C",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS4lwrxofkVF3J44hurl9rWSBm0VwE2qHTCXkb-dfl6qdb5If2S_dWsILC1UEBDkYkaJSw&usqp=CAU",
      },
      {
        name: "Python",
        image:
          "https://static.vecteezy.com/system/resources/previews/012/697/295/original/3d-python-programming-language-logo-free-png.png",
      },
      {
        name: "Data structure & Algorithim",
        image:
          "https://cdn.hackr.io/uploads/topics/1527244435zqmNp2BGzh.png",
      },
      {
        name: "DBMS",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcnaYCELk-MeSCeUkQVdw0pyy2JnncIvS8FA&usqp=CAU",
      },

    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
     {
        name: "AWS",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
     },
      {
        name: "Netlify",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/netlify/netlify-original.svg",
      },
      {
        name: "VS Code",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
      },
      {
        name: "Postman",
        image:
          "https://cdn.worldvectorlogo.com/logos/postman.svg",
      },

      {
        name: "Vercel",
        image:
          "https://assets.vercel.com/image/upload/front/favicon/vercel/180x180.png",
      },
     
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: trialshoppyLogo,
    role: "software Developer",
    company: "Trialshopy",
    date: "Nov2024 - current",
    desc: "Developed and optimized scalable full-stack features for a high-traffic e-commerce platform using React.js, Node.js, Express.js, and MySQL. Architected REST APIs with efficient pagination, reducing response payloads and improving endpoint performance. Implemented optimized infinite scrolling to deliver a seamless browsing experience and faster page loads. Enhanced database performance by designing optimized SQL queries, indexing strategies, and schema improvements, resulting in significantly faster query execution and improved application scalability under high user traffic",
    skills: [
      "React js",
      "Next Js",
      "JavaScript",
      "TypeScript",
      "Node Js",
      "MongoDB",
      "Express js"
      
    ],
    // doc: "https://mibkrwgmmusaaj1g.public.blob.vercel-storage.com/Trialshopy%20certificate%20image-t1NXsgbZyw7HiPUUX4GYYSEa0ql0vN.png",
  },
  {
    id: 0,
    img: nextcallerLogo,
    role: "Frontend Engineer Intern",
    company: "NeXtCaller",
    date: "May 2022 -July2022",
    desc: "Built and optimized scalable backend services using Flask (Python) and RESTful APIs, improving application performance through efficient query design and optimized database interactions. Applied modular software design principles to create reusable, maintainable codebases. Worked collaboratively with frontend and design teams to integrate APIs, enabling seamless communication between backend services and user interfaces while ensuring a reliable and responsive user experience",
    skills: [
      "Python",
      "Flask ",
      "REST APIs ",
      "MySQL",
      "HTML",
      "CSS",
      "JavaScript",
      "Git",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 1,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA4CAMAAABuU5ChAAAA+VBMVEX////pQjU0qFNChfT6uwU0f/O4zvs6gfSJr/j6twDoOisjePPoNSXpPjDrWU/oLRr+9vZ7pff/vAAUoUAkpEn0ran619b82pT7wgD+68j947H/+e7//PafvPm/0vuBw5Df7+P63tz3xcPxl5HnJQ7qUEXxj4n4z83zoJzqSz/vgXrucWrsY1r1tbHrSBPoOjbvcSr0kx74rRH80XntZC3xhSPmGRr86+r4sk/936EJcfPS3/yowvnbwVKjsTjx9f5urEjkuBu9tC+ErkJyvoRRpj2az6hWs23j6/0emX2z2btAiuI8k8AyqkE5nZU1pGxCiOxVmtHJ5M+PSt3WAAACGElEQVRIieWSa3fSQBCGk20CJRcW2AWKxgJtqCmieNdatV5SUtFq5f//GJeE7CXJJOT4TZ+PO+c58+7MaNr/SWd60mecTDs1pMFp28dODPZnZw/369TXseXqHNfCblDdte84krTDwUFFwnMnJyXm+bSsmZ/vlcb1+6A2x5C1xYeyPgIyJlhtYDjzjOYyZA3oFighLYxni8UMY6dCG/jy9KzTQfI8DXSnTNN0kcl1lNE9dlxYC8TnnEVmAJ02qHlPllyb58vgmQ2Np0tYgzGMo2ex6IKRihi1mPhcZyYuO8McL4yYl0vrrI6mJZpx9Or1mzqa10rFt8p7o5ArXh+lXutC8d6ZBdiXvH6PeyPFsw8KMBu8fsG9+3t473l9yD1vD+/BX3v1cgqv3lzE/8A9NCUK5sn33vugeN1DQTcVTbG/9M56H+lEAzg2d54t7iW5657xCdEx5PF+B9Lj9oO9z4hBgIZX6YyaXfmZaV9QQkU781h+Hra+7jQaFv6Or8RW3r1rhErES641D9XKigox8jJaQxyAfZOpIQm6kiuT6BvfujqVuEpkkY43u+d1RBBF35v55aVJidKSEBRFiJAk/+0PM3NjgjFFMLc/WVYzlzImLBPprzvzrlBjHUmZSH8DmqatS0QSZtcjTxUBWSlZw1bckhaYlISTcm1rIqKolJJxtRWnXUVscTFsjWFFwoy7WTM2+zX69/gDaLcy7SET9nsAAAAASUVORK5CYII=",
    role: "Google cloud",
    company: "Google",
    date: "feb2021 - mar 2021",
    desc: "Participating in the Google Cloud program has significantly enhanced my proficiency in cloud computing. Through immersive learning modules and hands-on projects, I've gained valuable insights into leveraging Google Cloud's technologies for scalable solutions. ",
    skills: [
      "Cloud SQL",
      "BigQuery",
      "Dataflow",
      "Bigtable",

    
    ],
  }
 

];

export const education = [
  {
    id: 0,
    img: nitpatnaLogo,
    school: "National Institute of Technology Patna",
    date: "Oct 2020 - June 2024",
    grade: "8.5 CGPA",
    desc: "I hold a Bachelor's degree in Electrical Engineering from the National Institute of Technology (NIT) Patna with a CGPA of **8.5**. During my academic journey, I built a strong foundation in Data Structures and Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks. I also contributed to the Google Developer Student Club (GDSC), collaborating on projects that strengthened my problem-solving, software development, and teamwork skills.",
    degree: "Bachelor of Technology - BTech, Electrical Engineering ",
  },
  {
    id: 1,
    img: "https://mibkrwgmmusaaj1g.public.blob.vercel-storage.com/nc%20college-JL014VgUOUiktyjba1WTN09qcJv7oT.png",
    school: "Dr.N.C. College Benipatti",
    date: "Apr 2017 - Apr 2019",
    grade: "85.2%",
    desc: "I completed my class 12 high school education at Dr.N.C. College ,Benipattii, where I studied Science with pHysics, chemistrey and math . Apart from this  i have also studied literature in Hindi and English. Alongside academics, I actively participated in extracurricular activities, honing my leadership and teamwork skills through roles in student government and sports teams.",
    degree: "(XII), Science PCM",
  },
  {
    id: 2,
    img: "https://mibkrwgmmusaaj1g.public.blob.vercel-storage.com/vmv-399VACTfyZLOLIPnfoHVat6KccDK9e.png",
    school: "Vivekanand Mission Vidyapeeth Madhopur, Madhubani",
    date: "Apr 2016- Apr 2017",
    grade: "89.3%",
    desc: "I completed my class 10 education at Vivekanand Mission Vidyapeeth Madhopur, Madhubani, where I studied science, social science  and literature.",
    degree: "(X) standard",
  },
];

export const projects = [
  {
    id: 9,
    title: "Facebook clone",
    date: "Jun 2023 - Jul 2023",
    description:
      "Facebook clone is social networking platform .Led the development of this project, implementing core features and functionalities to create a social mediaplatform from scratch. This platform offers cool features like a wall to share your post,comment,chat with people. Built the user interface using modern web technologies such as HTML5, CSS3 and Ejs to ensure an engaging and responsive user experience. Established server-side logic using back-end technologies like Node-js,MongoDB, Express-js, managing user data,authentication, and authorization.Implemented secure user authentication using OAuth or JWT to safeguard user accounts and sensitive information.",
    image:
      "https://mibkrwgmmusaaj1g.public.blob.vercel-storage.com/coonect-i-EIiIwco7lhYriO6uj9X0jnU3pJgJhO.png",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
      "Jquery",
      "Ejs",
      "Node js",
      "Express js",
      "MongoDb",
      "Node Js",
      "OAuth",
      "passport"

    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Trackify",
    webapp: "http://52.90.101.24:8000/",
  },
  {
    id: 0,
    title: "The Fit club",
    date: "Apr 2022 - May 2022",
    description:
      "Design and Developed modern a visually appealing layout showcasing the gym’s facilities, services, and promotions. created a responsive and visually appealing user interface using HTML5, CSS3, and React js ensuring optimal user experience across devices. Utilize React components for modular development and easier maintenance.Use CSS animations or transitions for interactive elements to enhance user experience. Gained insights of various front-end development concepts through this project.",
    image:
      "https://mibkrwgmmusaaj1g.public.blob.vercel-storage.com/gym-ekuVJnVsg8AenL8b6PlUTT5JSbligs.png",
    tags: ["React Js", "HTML", "CSS", "Node js", "Javascript"],
    category: "web app",
    // github: "https://github.com/rishavchanda/Podstream",
    webapp: "https://fitnessworld.pages.dev/",
    
  },
  {
    id: 1,
    title: "Simulation Tool",
    date: "Oct 2023 - Dec 2023",
    description:
      "This is a web-based tools for simulating basic electrical and electronics circuits.These tools offer a convenient and interactive way to explore the principles of circuit design and analysis.  Simulation allows us to model and analyze the behavior of electrical and electronics circuits without the need for physical components.It enables us to test different circuit configurations, evaluate performance, and troubleshoot potential issues. With web-based tools, these simulations can be performed conveniently in a virtual environment.",
    image:
      "https://mibkrwgmmusaaj1g.public.blob.vercel-storage.com/simulation%20app-t6O4wL2jX6ZKYTFkEpUzufaAXSgDWn.png",
    tags: [
      "Javascript",
      "HTML",
      "CSS",
  
    ],
    category: "web app",
    // github: "https://github.com/rishavchanda/Project-Management-App",
    webapp: "https://minor-project-ee.netlify.app/",
  },

  // {
  //   id: 5,
  //   title: "Todo Web App",
  //   date: "Jun 2021",
  //   description:
  //     " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
  //   image:
  //     "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
  //   tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
  //   category: "web app",
  //   github: "https://github.com/rishavchanda/Todo-Web-App",
  //   webapp: "https://rishav-react-todo.netlify.app/",
  // },
 

];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
